import { Maybe, Undef } from 'types/UtilityTypes';

import { LTLCustomer } from '../../types';

export function getThreeGNumericTradingPartnerId(
  customer: Maybe<LTLCustomer>
): Undef<string> {
  if (!customer?.externalId) {
    return undefined;
  }

  const trimmed = customer.externalId.trim();
  if (/^\d+$/.test(trimmed)) {
    return trimmed;
  }

  return undefined;
}
